export type CongressId = string;

export interface Congress {
  readonly id: CongressId; // `${slug}-${annee}` — compat route :congressId
  readonly slug: string;
  readonly annee: string;
  readonly label: string; // `${nom} ${annee}`
  readonly isCurrent?: boolean;
  readonly disabled?: boolean;
  readonly dateDebut?: string | null;
  readonly dateFin?: string | null;
  readonly dateOuvertureInscriptions?: string | null;
}

interface EditionDto {
  readonly id: number;
  readonly annee: string;
  readonly dateDebut: string | null;
  readonly dateFin: string | null;
  readonly dateOuvertureInscriptions: string | null;
  readonly isPast: boolean;
  readonly isCurrent: boolean;
}

interface CongresDto {
  readonly slug: string;
  readonly nom: string;
  readonly editions: readonly EditionDto[];
}

function isCongresDtoArray(body: unknown): body is readonly CongresDto[] {
  return (
    Array.isArray(body) &&
    body.every(
      (c) =>
        typeof c === 'object' &&
        c !== null &&
        typeof (c as Record<string, unknown>)['slug'] === 'string' &&
        Array.isArray((c as Record<string, unknown>)['editions']),
    )
  );
}

/** Aplatit `[{slug,nom,editions:[...]}]` en une liste de congrès (une entrée par édition). */
export function mapCongresList(body: unknown): Congress[] {
  if (!isCongresDtoArray(body)) {
    return [];
  }
  return body.flatMap((c) =>
    c.editions.map((ed) => ({
      id: `${c.slug}-${ed.annee}`,
      slug: c.slug,
      annee: ed.annee,
      label: `${c.nom} ${ed.annee}`,
      isCurrent: ed.isCurrent,
      dateDebut: ed.dateDebut,
      dateFin: ed.dateFin,
      dateOuvertureInscriptions: ed.dateOuvertureInscriptions,
    })),
  );
}
